import { __extends } from "tslib";
import { clone } from "../../utils/array";
import { UndoOperation } from "../mdl/SceneElement";
import { AbstractCommand } from "./AbstractCommand";
var AbstractInsertDeleteElements = /** @class */ (function (_super) {
    __extends(AbstractInsertDeleteElements, _super);
    function AbstractInsertDeleteElements(pApp, pElements) {
        var _this = _super.call(this, pApp) || this;
        _this.mElements = clone(pElements);
        _this.mElementsDeleted = false;
        //store element and node parents
        _this.mElementParents = new Array();
        _this.mElementUndoData = new Array();
        _this.mNodeParents = new Array();
        for (var _i = 0, _a = _this.mElements; _i < _a.length; _i++) {
            var tElement = _a[_i];
            _this.mElementParents.push(tElement.getParentElement());
            _this.mElementUndoData.push(null);
            _this.mNodeParents.push(tElement.node.parent);
        }
        return _this;
    }
    AbstractInsertDeleteElements.prototype.isAvailable = function () {
        return (this.mElements != null);
    };
    AbstractInsertDeleteElements.prototype.isUndoable = function () {
        return (true);
    };
    AbstractInsertDeleteElements.prototype.dispose = function () {
        if (this.mElementsDeleted) {
            for (var _i = 0, _a = this.mElements; _i < _a.length; _i++) {
                var tElement = _a[_i];
                tElement.dispose();
            }
        }
        this.mElements = undefined;
    };
    AbstractInsertDeleteElements.prototype.deleteElements = function () {
        var tModel = this.mApp.model;
        try {
            tModel.beginSelectionChange();
            //get delete undo data
            for (var i = 0; i < this.mElements.length; ++i) {
                this.mElementUndoData[i] = this.mElements[i].saveUndoData(UndoOperation.Delete);
            }
            //start change section for parents
            for (var i = 0; i < this.mElementParents.length; ++i) {
                var tParent = this.mElementParents[i];
                if (tParent != null)
                    tParent.beginChange();
            }
            for (var i = 0; i < this.mElements.length; ++i) {
                tModel.removeElement(this.mElements[i], true, false);
            }
        }
        finally {
            //end change section for parents
            for (var i = 0; i < this.mElementParents.length; ++i) {
                var tParent = this.mElementParents[i];
                if (tParent != null)
                    tParent.endChange();
            }
            tModel.endSelectionChange();
        }
        this.mElementsDeleted = true;
        this.mApp.viewer.requestRenderFrame();
    };
    AbstractInsertDeleteElements.prototype.insertElements = function (pAddToScene) {
        var tModel = this.mApp.model;
        try {
            //start change section for parents
            for (var i = 0; i < this.mElementParents.length; ++i) {
                var tParent = this.mElementParents[i];
                if (tParent != null)
                    tParent.beginChange();
            }
            for (var i = 0; i < this.mElements.length; ++i) {
                tModel.addElement(this.mElements[i], this.mNodeParents[i], pAddToScene);
            }
            //load delete undo data
            for (var i = 0; i < this.mElements.length; ++i) {
                if (this.mElementUndoData[i] != null)
                    this.mElements[i].loadUndoData(UndoOperation.Delete, this.mElementUndoData[i]);
            }
        }
        finally {
            //end change section for parents
            for (var i = 0; i < this.mElementParents.length; ++i) {
                var tParent = this.mElementParents[i];
                if (tParent != null)
                    tParent.endChange();
            }
        }
        this.mElementsDeleted = false;
        this.mApp.viewer.requestRenderFrame();
    };
    return AbstractInsertDeleteElements;
}(AbstractCommand));
export { AbstractInsertDeleteElements };
var DeleteElements = /** @class */ (function (_super) {
    __extends(DeleteElements, _super);
    function DeleteElements(pApp, pElements) {
        return _super.call(this, pApp, pElements) || this;
    }
    DeleteElements.prototype.execute = function (pParameter) {
        return (this.redo().then(function () { return (true); }));
    };
    DeleteElements.prototype.undo = function () {
        this.insertElements(true);
        return (Promise.resolve());
    };
    DeleteElements.prototype.redo = function () {
        this.deleteElements();
        return (Promise.resolve());
    };
    return DeleteElements;
}(AbstractInsertDeleteElements));
export { DeleteElements };
var InsertElements = /** @class */ (function (_super) {
    __extends(InsertElements, _super);
    function InsertElements(pApp, pElements) {
        return _super.call(this, pApp, pElements) || this;
    }
    InsertElements.prototype.execute = function (pParameter) {
        this.insertElements(false); //nodes should already be part of the scene
        return (Promise.resolve(true));
    };
    InsertElements.prototype.undo = function () {
        this.deleteElements();
        return (Promise.resolve());
    };
    InsertElements.prototype.redo = function () {
        this.insertElements(true);
        return (Promise.resolve());
    };
    return InsertElements;
}(AbstractInsertDeleteElements));
export { InsertElements };
